import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import footerBG from '../../assets/img/footer/bg-5.jpg';
import newLogo2 from '../../assets/img/logo/new-logo.png';

const FooterThree = (props) => {
  const { footerClass } = props;
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage('Please enter a valid email.');
      return;
    }

    try {
      const res = await fetch('https://ricgop.online/api/subscribe.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (data.success) {
        setMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        setMessage(data.message || 'Subscription failed. Try again.');
      }
    } catch (err) {
      setMessage('Something went wrong. Please try again later.');
    }
  };

  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : 'it-footer-area it-footer-style-5 black-bg fix z-index p-relative pb-70'
        }
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="it-footer-top-area pt-115 pb-120 mb-120">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="it-footer-top-left">
                  <h3 className="it-footer-top-title text-white" style={{ fontSize: '24px', fontWeight: 'bold' }}>
                    <span
                      style={{
                        color: 'rgb(238 52 78)',
                        fontSize: '40px',
                        fontWeight: '900',
                        textShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
                      }}
                    >
                      Rawalpindi
                    </span>{' '}
                    Institute Of{' '}
                    <span
                      style={{
                        color: '#34b9ee',
                        fontSize: '35px',
                        fontWeight: '900',
                        textShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
                        animation: 'bounceIn 1.5s ease-out',
                      }}
                    >
                      Cardiology
                    </span>
                  </h3>
                  <p className="mb-0">
                    We are committed to offering comprehensive cardiovascular care to all individuals, regardless of
                    their background or financial status. As a government hospital, we take pride in providing most of
                    our services free of charge, ensuring accessible healthcare for every community.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="it-footer-top-right">
                  <h3 className="it-footer-top-right-title text-white mb-15">Subscribe With Us</h3>
                  <p>For any help mail us. 24/7 emergency services</p>
                  <div className="it-footer-input-box p-relative mt-30">
                    <form onSubmit={handleSubscribe}>
                      <input
                        type="email"
                        placeholder="Your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit" className="it-btn-theme red-bg">
                        <Button btnText="Subscribe" />
                      </button>
                      {message && <p style={{ color: 'white', marginTop: '10px' }}>{message}</p>}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 col-sm-10 mb-50 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
              <div className="it-footer-widget footer-col-1">
                <div className="it-footer-logo" style={{ display: 'flex', alignItems: 'center' }}>
                  <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={newLogo2} alt="Logo" style={{ width: '150px', height: 'auto', marginRight: '10px' }} />
                    <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>
                      <span style={{ color: 'rgb(238, 52, 78)' }}>Rawalpindi</span> Institute Of{' '}
                      <span style={{ color: '#34b9ee' }}>Cardiology</span>
                    </span>
                  </Link>
                </div>
                <div className="it-footer-text pb-15">
                  <p>
                    Welcome to RIC, where compassionate care meets advanced cardiovascular expertise. Our dedicated team of specialists is committed to providing the highest standard of treatment for your heart health.
                  </p>
                </div>
                <div className="it-footer-social">
                  <a href="https://web.facebook.com/profile.php?id=61569572901195"><i className="fa-brands fa-facebook-f"></i></a>
                  <a href="https://www.instagram.com/riccardiology/"><i className="fa-brands fa-instagram"></i></a>
                  <a href="https://www.linkedin.com/in/rawalpindi-institute-of-cardiology-52737b354/"><i className="fa-brands fa-linkedin"></i></a>
                  <a href="https://www.youtube.com/@rawalpindiinstituteofcardi3365"><i className="fa-brands fa-youtube"></i></a>
                </div>
              </div>
            </div>

            <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-7 mb-50 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".5s">
              <div className="it-footer-widget footer-col-2">
                <h4 className="it-footer-widget-title">our services:</h4>
                <div className="it-footer-list">
                  <ul>
                    <li><a href="/"><i className="fa-regular fa-angle-right"></i>Primary Care</a></li>
                    <li><a href="/"><i className="fa-regular fa-angle-right"></i>Speciality Care</a></li>
                    <li><a href="/"><i className="fa-regular fa-angle-right"></i>Emergency Care</a></li>
                    <li><a href="/"><i className="fa-regular fa-angle-right"></i>Surgical Services</a></li>
                    <li><a href="/"><i className="fa-regular fa-angle-right"></i>Mental Health Service</a></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-2 col-lg-3 col-md-6 col-sm-5 mb-50 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".7s">
              <div className="it-footer-widget footer-col-3">
                <h4 className="it-footer-widget-title">quick links:</h4>
                <div className="it-footer-list">
                  <ul>
                    <li><a href="/"><i className="fa-regular fa-angle-right"></i>Home</a></li>
                    <li><a href="/about-us"><i className="fa-regular fa-angle-right"></i>About Us</a></li>
                    <li><a href="/service"><i className="fa-regular fa-angle-right"></i>Services</a></li>
                    <li><a href="/appointments"><i className="fa-regular fa-angle-right"></i>Appointment</a></li>
                    <li><a href="/event"><i className="fa-regular fa-angle-right"></i>Events</a></li>
                    <li><a href="/contact"><i className="fa-regular fa-angle-right"></i>Contact Us</a></li>
                    <li><a href="/privacy-policy"><i className="fa-regular fa-angle-right"></i>Privacy Policies</a></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".9s">
              <div className="it-footer-widget footer-col-4">
                <h4 className="it-footer-widget-title">newsletter:</h4>
                <div className="it-footer-input-box p-relative mb-25">
                  <form onSubmit={handleSubscribe}>
                    <input
                      className="mb-30"
                      type="email"
                      placeholder="Enter your email:"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button className="it-btn-theme red-bg" type="submit">
                      <Button btnText="Subscribe now" />
                    </button>
                  </form>
                </div>
                <div className="it-footer-agree">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="flexCheckDefault" />
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                      I agree to email receive.
                    </label>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="it-copyright-area it-copyright-height it-copyright-style-4">
        <div className="container">
          <div className="row">
            <div className="col-12 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
              <div className="it-copyright-text text-center">
                <p>
                  Copyright © 2025 <a href="ricgop,online">RIC</a> || All Right Reserved Design by IT Department, RIC
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
